import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=56e07b0f&"
import script from "./Logotype.vue?vue&type=script&lang=ts&"
export * from "./Logotype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports